// The only prop you need to pass in is onSubmit
// to get the form data
import { reduxForm } from 'redux-form'
import Form from './Form'

export default formId => reduxForm({
  form: formId
})(Form)


// WEBPACK FOOTER //
// ./src/components/Form/index.js